/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Highlight from '../Highlight';
import styles from './styles.scss';

const propTypes = {
  debugResult: PropTypes.object.isRequired,
};

const kSampleCode = (
`
//   Return value will show in here.
`
);

const kResult = `/*
{
  result1: 100,
  result2: 300
}
*/`;

class DebugSample extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      debugResult: `${kSampleCode}${kResult}`,
    };
  }

  componentWillReceiveProps(nextProps) {
    let { debugResult } = nextProps;
    try {
      debugResult = JSON.stringify(debugResult);
    } catch (err) {
      debugResult = 'none value returned';
    }
    this.setState({ debugResult: `${kSampleCode}${debugResult}` });
  }

  render() {
    const { debugResult } = this.state;
    return (
      <div className={styles.sample}>
        <pre>
          <code>
            <Highlight code={debugResult} />
          </code>
        </pre>
      </div>
    );
  }
}

DebugSample.propTypes = propTypes;

const mapStateToProps = state => ({
  debugResult: state.parser.getDebugResult,
});

export default connect(mapStateToProps, null)(DebugSample);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/ParseView/coms/DebugSample/index.jsx